import React from 'react';
import { Hero } from '../components/Sections/Hero';
import { FeaturesGrid } from '../components/Sections/FeaturesGrid';
import { StatsBlock } from '../components/Sections/StatsBlock';
import { FeatureDetails } from '../components/Sections/FeatureDetails';
import { PricingTable } from '../components/Sections/PricingTable';
import { AboutUs } from '../components/Sections/AboutUs';
import { FaqSection } from '../components/Sections/FaqSection';

export const HomePage = () => {
  return (
    <main id="main-content">
      <Hero />
      <FeaturesGrid />
      <StatsBlock />
      <FeatureDetails />
      <AboutUs />
      <PricingTable />
      <FaqSection />
    </main>
  );
};

export default HomePage;